/* FORGE PDP — variant chips, gallery swap, sticky ATC, back-in-stock toggle.
   Dependency-free; Dawn's <product-form> handles the AJAX add + drawer open. */
(function () {
  'use strict';

  var dataEl = document.querySelector('[data-forge-variants]');
  if (!dataEl) { return; }
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var variants = data.variants || [];
  var optionCount = (data.options || []).length;
  var sizeAxis = 0;
  (data.options || []).forEach(function (name, i) {
    var n = String(name).toLowerCase();
    if ((n.indexOf('size') > -1 || n.indexOf('length') > -1) && sizeAxis === 0) { sizeAxis = i; }
  });

  var buy = document.querySelector('.forge-buy');
  var form = buy ? buy.querySelector('form[action*="/cart/add"]') : null;
  var idInput = form ? form.querySelector('[name="id"]') : null;
  var atcBtn = document.querySelector('[data-forge-atc]');
  var atcLabel = document.querySelector('[data-forge-atc-label]');
  var priceEl = document.querySelector('[data-forge-price]');
  var stickyPrice = document.querySelector('[data-forge-sticky-price]');
  var stickyAtc = document.querySelector('[data-forge-sticky-atc]');
  var bisAnchor = document.querySelector('[data-forge-bis]');

  /* ----- variant selection ----- */
  var selected = [];
  document.querySelectorAll('[data-forge-option]').forEach(function (row) {
    var idx = parseInt(row.getAttribute('data-forge-option'), 10);
    var on = row.querySelector('button.on');
    selected[idx] = on ? on.getAttribute('data-value') : null;
  });
  if (!selected.length && variants.length) { selected = variants[0].options.slice(); }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], match = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== null && v.options[j] !== opts[j]) { match = false; break; }
      }
      if (match) { return v; }
    }
    return null;
  }

  function anyAvailableWith(idx, value) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], match = true;
      for (var j = 0; j < optionCount; j++) {
        if (j === idx) { if (v.options[j] !== value) { match = false; break; } }
        else if (selected[j] !== null && v.options[j] !== selected[j]) { match = false; break; }
      }
      if (match && v.available) { return true; }
    }
    return false;
  }

  function apply() {
    var v = findVariant(selected);
    var available = !!(v && v.available);
    if (v && idInput) { idInput.value = v.id; }
    if (v && priceEl) { priceEl.textContent = v.price; }
    if (v && stickyPrice) { stickyPrice.textContent = v.price; }
    if (atcBtn) { atcBtn.toggleAttribute('disabled', !available); }
    if (stickyAtc) {
      stickyAtc.toggleAttribute('disabled', !available);
      stickyAtc.textContent = available ? 'Add to cart' : 'Sold out';
    }
    if (atcLabel) { atcLabel.textContent = available ? 'Add to cart — ' + v.price : 'Sold out'; }
    /* reveal the Klaviyo back-in-stock anchor only when the selection is unavailable */
    if (bisAnchor) { bisAnchor.toggleAttribute('hidden', available); }
    if (v && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    /* 2026-10-09 — Klaviyo's back-in-stock script re-checks stock ONLY on a bubbling
       `change` event; our size chips are buttons and never fire one, so its inline
       display:none from page load (default size in stock) stuck and "Notify me" never
       showed on a sold-out size (Katelyn, large elbow sleeve). Fire it AFTER replaceState:
       Klaviyo reads the variant from the URL. Dispatched from the anchor, whose ancestors
       carry no other change listener (forge-buy < grid < section < main < body). */
    if (bisAnchor) { bisAnchor.dispatchEvent(new Event('change', { bubbles: true })); }
    /* let dependent modules (colorway siblings) react to the selection.
       sizeShort is the SAME short code the chip shows (rendered by the forge-size-short
       snippet into data-short), so the colorway markers read "no 3XS", never a second
       transliteration of the size that could drift from the chips. */
    var sizeRow = document.querySelector('[data-forge-option="' + sizeAxis + '"]');
    var sizeChip = sizeRow ? sizeRow.querySelector('button.on') : null;
    document.dispatchEvent(new CustomEvent('forge:variant-change', {
      detail: {
        variant: v,
        available: available,
        sizeValue: selected[sizeAxis] || null,
        sizeShort: sizeChip ? sizeChip.getAttribute('data-short') : null,
        price: v ? v.price : null
      }
    }));

    /* sale / compare-at + stock messaging keep pace with the selection */
    var cmp = document.querySelector('[data-forge-compare]');
    var flag = document.querySelector('[data-forge-saleflag]');
    if (cmp && v) {
      var onSale = v.compare_at_price_raw && v.price_raw && v.compare_at_price_raw > v.price_raw;
      cmp.hidden = !onSale;
      if (onSale) { cmp.textContent = v.compare_at_price; }
      if (flag) { flag.hidden = !onSale; }
    }
    var stockMsg = document.querySelector('[data-forge-stockmsg]');
    if (stockMsg && v) {
      var low = available && typeof v.inventory === 'number' && v.inventory > 0 &&
        v.inventory <= (parseInt(stockMsg.getAttribute('data-threshold'), 10) || 6);
      stockMsg.hidden = !low;
      if (low) { stockMsg.textContent = 'Low stock: ' + v.inventory + ' left'; }
    }

    /* per-chip availability shading — and the SAME state announced to assistive tech.
       Accessibility audit finding #1, 2026-08-17: availability was conveyed by the `oos`
       class alone, i.e. by strikethrough and colour, which a screen reader cannot see. A
       shopper using one could not tell a sold-out size from an available one on the control
       that completes the purchase. Because availability is computed here against the variant
       matrix rather than server-side, the accessible name has to be maintained here too —
       state that changes at runtime must be announced at runtime.
       The chip stays clickable on purpose: clicking a sold-out size triggers the rescue in
       forge-siblings.js that lists which colorways have it. */
    document.querySelectorAll('[data-forge-option]').forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-forge-option'), 10);
      var optName = row.getAttribute('aria-label') || '';
      row.querySelectorAll('button').forEach(function (b) {
        var out = !anyAvailableWith(idx, b.getAttribute('data-value'));
        b.classList.toggle('oos', out);
        var base = optName + ' ' + b.getAttribute('data-value');
        b.setAttribute('aria-label', out ? base + ', sold out' : base);
      });
    });
  }

  document.querySelectorAll('[data-forge-option]').forEach(function (row) {
    var idx = parseInt(row.getAttribute('data-forge-option'), 10);
    row.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) { return; }
      selected[idx] = b.getAttribute('data-value');
      /* aria-pressed moves with the `on` class. Selection used to be carried by the class
         alone, so a screen-reader user could not tell which size was chosen. */
      row.querySelectorAll('button').forEach(function (x) {
        x.classList.remove('on');
        x.setAttribute('aria-pressed', 'false');
      });
      b.classList.add('on');
      b.setAttribute('aria-pressed', 'true');
      var lbl = document.querySelector('[data-forge-optlbl="' + idx + '"]');
      if (lbl) {
        /* Chips now carry the SHORT code only, so the label is the one place the full
           value (and, for stores with bare option values, the forge.size_ranges
           measurement) is spelled out. Mirrors the server-rendered markup exactly. */
        var range = b.getAttribute('data-range');
        lbl.textContent = (data.options[idx] || 'Option') + ' — ' + selected[idx] +
          (range ? ' (' + range + ')' : '');
      }
      apply();
    });
  });
  apply();

  /* ----- gallery thumb swap ----- */
  var main = document.querySelector('[data-forge-gal-main]');
  var thumbs = document.querySelector('[data-forge-thumbs]');
  if (main && thumbs) {
    /* The main image renders at its natural shape, so switching thumbs legitimately changes
       the gallery height (approved by Brandon 2026-08-16). Two things keep that from reading
       as breakage:
         1. --ar and the width/height attributes are set BEFORE the node is inserted, so the
            correct box exists at insert time instead of collapsing to zero and snapping open
            when the file lands.
         2. the old->new height is animated, since 1 makes both heights measurable. Skipped
            under prefers-reduced-motion, which is also why it is an animation of the slot and
            not a CSS transition — nothing to unwind if it does not run.

       The hidden-document guard is NOT defensive noise. A document animation timeline does not
       advance while the tab is hidden, so an in-flight height animation freezes at currentTime 0
       and PINS the slot at the OLD height — the new image then sits letterboxed inside a stale
       box for as long as the tab stays backgrounded. Observed directly on 2026-08-16 (the
       verification pane runs tabs hidden, which is what surfaced it): slot 393x330 around a
       393x238 image. So: never start one while hidden, and cancel one that is already running if
       the page goes away. Only ever one animation in flight; a fast tapper cancels the last. */
    var reduceMotion = function () {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
        document.documentElement.classList.contains('forge-motion-off');
    };
    var heightAnim = null;
    function stopHeightAnim() {
      if (heightAnim) { heightAnim.cancel(); heightAnim = null; }
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stopHeightAnim(); }
    });
    function swapMain(node, ar) {
      stopHeightAnim();
      var before = main.offsetHeight;
      if (ar > 0) { main.style.setProperty('--ar', ar); } else { main.style.removeProperty('--ar'); }
      main.innerHTML = '';
      main.appendChild(node);
      var after = main.offsetHeight;
      if (before && after && before !== after && !reduceMotion() && main.animate && !document.hidden) {
        heightAnim = main.animate(
          [{ height: before + 'px' }, { height: after + 'px' }],
          { duration: 220, easing: 'cubic-bezier(.22,.61,.36,1)' }
        );
        /* fill is 'none', so a finished animation releases the height on its own; this just
           drops the reference so a later cancel() cannot touch a dead animation. */
        if (heightAnim.finished && heightAnim.finished.then) {
          heightAnim.finished.then(function () { heightAnim = null; }, function () {});
        }
      }
    }

    thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('.t');
      if (!t) { return; }
      thumbs.querySelectorAll('.t').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      var vsrc = t.getAttribute('data-video-sources');
      if (vsrc) {
        var video = document.createElement('video');
        video.className = 'main-media';
        video.muted = true; video.loop = true; video.autoplay = true;
        video.playsInline = true; video.setAttribute('playsinline', '');
        /* Reduced motion: this JS-built element previously autoplayed regardless.
           Now it stays still and offers controls so the visitor can start it
           deliberately (and therefore stays focusable). Otherwise it follows the
           same contract as every server-rendered forge loop — decorative, out of
           the tab order, the thumb button carrying the accessible name. */
        if ((window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
            document.documentElement.classList.contains('forge-motion-off')) {
          video.autoplay = false;
          video.removeAttribute('autoplay');
          video.setAttribute('controls', '');
        } else {
          video.setAttribute('aria-hidden', 'true');
          video.setAttribute('tabindex', '-1');
        }
        try {
          JSON.parse(vsrc).forEach(function (s) {
            var source = document.createElement('source');
            source.src = s.url; source.type = s.type;
            video.appendChild(source);
          });
        } catch (err) { return; }
        /* The loop is authored square and CSS pins it there; ar 1 keeps the cap consistent. */
        swapMain(video, 1);
      } else if (t.getAttribute('data-img')) {
        var img = document.createElement('img');
        img.className = 'main-media';
        var iw = parseInt(t.getAttribute('data-w'), 10);
        var ih = parseInt(t.getAttribute('data-h'), 10);
        if (iw > 0 && ih > 0) {
          img.setAttribute('width', iw);
          img.setAttribute('height', ih);
        }
        img.src = t.getAttribute('data-img');
        img.alt = t.getAttribute('data-alt') || '';
        swapMain(img, (iw > 0 && ih > 0) ? iw / ih : 0);
      }
    });
  }

  /* ----- sticky ATC bar ----- */
  var sticky = document.querySelector('[data-forge-sticky]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.toggleAttribute('inert', !show);
      });
    }, { threshold: 0 });
    sio.observe(buy);
  }
  if (stickyAtc && form) {
    stickyAtc.addEventListener('click', function () {
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });
  }
})();

/* ----- back-in-stock trigger: keyboard + popup focus (ACCESSIBILITY_RECHECK R3, 2026-10-20) -----
   The trigger is <a href="#" role="button"> (sections/forge-pdp.liquid) because Klaviyo's
   delegated handler keys off that class. A role="button" must also activate on Space; a bare
   anchor scrolls the page instead. Klaviyo then opens its form as #klaviyo-bis-iframe at the end
   of <body> with no title and leaves focus behind it on the page, so: name the frame, move focus
   into it, and hand focus back to the trigger when the popup closes. What happens INSIDE the
   frame (its fields, its close button) is Klaviyo's code, not ours. */
(function () {
  'use strict';
  var TITLE = 'Notify me when this size is back in stock';

  function frameOpen(f) {
    if (!f || !f.isConnected || !f.getClientRects().length) { return false; }
    var cs = window.getComputedStyle(f);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }

  /* The frame is about:blank written by Klaviyo's script, so it is same-origin and reachable.
     Inside it: Escape presses Klaviyo's own close button (it ignored Escape, measured
     2026-10-20), and Tab wraps between its first and last controls instead of leaving the
     popup for the page hidden behind it. Bound once per frame document. */
  function armFrame(f) {
    var doc;
    try { doc = f.contentDocument; } catch (err) { return; }
    if (!doc || doc.__forgeArmed) { return; }
    doc.__forgeArmed = true;
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        var x = doc.querySelector('.klaviyo-bis-close');
        if (x) { e.preventDefault(); x.click(); }
        return;
      }
      if (e.key !== 'Tab') { return; }
      var els = [].filter.call(doc.querySelectorAll('button, a[href], input:not([type=hidden]), select, textarea'),
        function (el) { return !el.disabled && el.getClientRects().length; });
      if (!els.length) { return; }
      var first = els[0], last = els[els.length - 1], at = doc.activeElement;
      if (e.shiftKey && (at === first || at === doc.body)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && at === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* Focusing the <iframe> element alone leaves the frame's own document unfocused, so its
     keydown listener never sees Escape. Put focus on the email field (or the frame window). */
  function focusInside(f) {
    try {
      var doc = f.contentDocument;
      var field = doc && doc.querySelector('input[type="email"]');
      if (field && field.getClientRects().length) { field.focus(); } else { f.contentWindow.focus(); }
    } catch (err) {}
  }

  /* Fallback if focus is back on the page while the popup is still open. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') { return; }
    var f = document.getElementById('klaviyo-bis-iframe');
    if (!frameOpen(f)) { return; }
    try {
      var x = f.contentDocument.querySelector('.klaviyo-bis-close');
      if (x) { e.preventDefault(); x.click(); }
    } catch (err) {}
  });

  function watchClose(f, trigger) {
    var iv = setInterval(function () {
      if (frameOpen(f)) { return; }
      clearInterval(iv);
      var a = document.activeElement;
      if (!a || a === document.body || a === f || !a.isConnected) { trigger.focus(); }
    }, 250);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') { return; }
    var t = e.target && e.target.closest && e.target.closest('.klaviyo-bis-trigger');
    if (!t) { return; }
    e.preventDefault();
    t.click();
  });

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.klaviyo-bis-trigger');
    if (!t) { return; }
    var tries = 0;
    var iv = setInterval(function () {
      var f = document.getElementById('klaviyo-bis-iframe');
      if (frameOpen(f)) {
        clearInterval(iv);
        f.setAttribute('title', TITLE);
        try { f.focus(); } catch (err) {}
        armFrame(f);
        focusInside(f);
        watchClose(f, t);
      } else if (++tries > 50) {
        clearInterval(iv);
      }
    }, 100);
  });
})();
